/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    blockquote: "blockquote",
    p: "p",
    a: "a",
    ol: "ol",
    li: "li",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: ".extend"
      }), "(", _jsx(_components.code, {
        children: ".extend"
      }), ")"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["styled-components v4 中删除了 ", _jsx(_components.code, {
          children: ".extend"
        }), " API。请改用 ", _jsx(_components.code, {
          children: "styled(StyledComponent)"
        }), "。有关更多信息，请参阅：", _jsx(_components.a, {
          href: "https://github.com/styled-components/styled-components/issues/1546",
          children: "https://github.com/styled-components/styled-components/issues/1546"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["¥The ", _jsx(_components.code, {
          children: ".extend"
        }), " API was removed in styled-components v4. Use ", _jsx(_components.code, {
          children: "styled(StyledComponent)"
        }), " instead. For more information, see: ", _jsx(_components.a, {
          href: "https://github.com/styled-components/styled-components/issues/1546",
          children: "https://github.com/styled-components/styled-components/issues/1546"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["这是一种创建新的 ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " 并扩展其规则的方法。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is a method that creates a new ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " and extends its rules."]
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsx(Code, {
                children: "TaggedTemplateLiteral"
              }), "\n"]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "A tagged template literal with your CSS and interpolations."
          })
        })]
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components'\n\nconst Component = styled.div`\n  color: red;\n`\n\nconst Component2 = Component.extend`\n  background: white;\n  color: blue;\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["返回一个新的 ", _jsx(_components.code, {
        children: "StyledComponent"
      }), "，其中新规则合并到调用此方法的组件的规则中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Returns a new ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " with the new rules merged into the ones of the component\nthis method was called on."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
